<script>
export default
{
    name: 'icon-button',

    props:
    {
        text: { default: '' },
        icon: { default: null }
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class='icon-button' on-click={this.onClick}>
                <div class='icon-container'>
                    <inline-svg class='icon' src={this.icon} />
                </div>
                <p class='text'>{ this.text }</p>
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
        }
    },

    watch:
    {
    },

    computed:
    {
    },

    methods:
    {
        onClick (event)
        {
            this.$emit('click', event, this)
        }
    },

    components:
    {
    }
}
</script>

<style lang='less' scoped>
@import '~@/styles/main.less';

.icon-button
{
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    height: auto;
    background-color: var(--theme-border-color-mega-light);
    border-radius: 4px;
    padding: 13px;
    transition: border-color .10s ease-out;
    cursor: pointer;

    &:hover
    {
        background-color: var(--theme-border-color-light);
        border-color: var(--theme-accent-color);
    }

    &:active
    {
        border-color: var(--theme-accent-color);
    }

    .icon-container
    {
        display: flex;
        justify-content: center;
        border-radius: 100px;
        background: var(--theme-accent-color-10-percent);
        .WidthHeight(15vw);

        .OnTablet({ .WidthHeight(8vw); });
        .OnDesktop({ .WidthHeight(3vw); });

        .icon
        {
            width: 55%;
            fill: var(--theme-accent-color);
        }
    }

    .text
    {
        margin-top: 10px;
        color: var(--theme-text-color-light);

        .OnTablet({ margin-top: 15px; })
    }
}
</style>


// WEBPACK FOOTER //
// src/components/IconButton.vue